import React, { useEffect, useRef, useState } from 'react';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// @ts-expect-error This does not exist outside of polyfill which this is doing
if (typeof Promise.withResolvers === 'undefined') {
  if (window)
    // @ts-expect-error This does not exist outside of polyfill which this is doing
    window.Promise.withResolvers = function () {
      let resolve, reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, resolve, reject };
    };
}
pdfjs.GlobalWorkerOptions.workerSrc =
  'https://unpkg.com/pdfjs-dist@4.4.168/legacy/build/pdf.worker.min.mjs';

const DisplayPdf = ({ resourceUrl }) => {
  const containerRef = useRef(null);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfWidth, setPdfWidth] = useState(800);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  const updateWidth = () => {
    if (containerRef.current) {
      setPdfWidth(containerRef.current.offsetWidth);
    }
  };

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  return (
    <div ref={containerRef} className="pdf-viewer margin-top--lg flex-container direction-column ">
      <Document file={resourceUrl} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} className="pdf-page" width={pdfWidth} />
      </Document>
      <div style={{ textAlign: 'center' }}>
        <IconButton disabled={pageNumber <= 1} onClick={previousPage} color="primary">
          <ArrowBack />
        </IconButton>
        <span>
          Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
        </span>
        <IconButton disabled={pageNumber >= numPages} onClick={nextPage} color="primary">
          <ArrowForward />
        </IconButton>
      </div>
      <style jsx>
        {`
          .pdf-viewer {
            border: 1px solid lightgrey;
            width: 100%;
            height: auto;
            overflow: auto;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          }
          .pdf-page {
            width: 100%;
            height: auto;
          }
          span {
            margin: 0px 10px;
          }
        `}
      </style>
    </div>
  );
};

export default DisplayPdf;
